import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {catchError, exhaustMap,} from 'rxjs/operators';
import { of} from 'rxjs';
import * as CostModuleActions from '../actions/cost-module.actions';
import * as CostModuleApiActions from '../actions/cost-module-api.actions';
import { CostModuleService } from '../../../cost-module/services/cost-module.service';

@Injectable()
export class CostModuleEffects {

  getServiceInfo$ = createEffect(() =>
    this._actions$.pipe(
      ofType(CostModuleActions.getServiceInfo.type),
      exhaustMap((action: any) => this._costModuleService.serviceInfo(action.unitIds)
        .pipe(
          exhaustMap((data) => of(CostModuleApiActions.getServiceInfoSuccess({data}))),
          catchError(error => of(CostModuleApiActions.getServiceInfoFailure({error})))
        )
      )
    )
  );

  constructor(
    private _actions$: Actions,
    private _costModuleService: CostModuleService,
  ) {
  }
}
